<template>
  <div class="row">
    <div class="col-20">
      <div
        v-if="draft"
        class="tip-text"
      >
        {{ isAdvertiser ? $t('view-CampaignsFiles.tip-info.advertiser.draft') : $t('view-CampaignsFiles.tip-info.influencer.draft') }}
      </div>
      <div
        v-else-if="publication"
        class="tip-text"
      >
        {{ isAdvertiser ? $t('view-CampaignsFiles.tip-info.advertiser.publication') : $t('view-CampaignsFiles.tip-info.influencer.publication') }}
      </div>
      <div
        v-else-if="disable"
        class="tip-text"
      >
        {{ isAdvertiser ? $t('view-CampaignsFiles.tip-info.advertiser.disable') : $t('view-CampaignsFiles.tip-info.influencer.disable') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    member: {
      type: Object,
      default: () => { return {} }
    },
    isAdvertiser: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    draft () {
      const correctStatuses = ['waiting_for_draft', 'waiting_fot_draft_approval']
      return correctStatuses.includes(this.member.status)
    },
    publication () {
      const correctStatuses = ['waiting_fot_publication', 'waiting_for_publication_approval']
      return correctStatuses.includes(this.member.status)
    },
    disable () {
      return !this.draft && !this.publication
    }
  }
}
</script>

<style lang="scss" scoped>
  .tip-text {
    font-size: 0.75rem;
    background: #F0F0F0;
    border-radius: 5px;
    padding: 1rem;
    text-align: left;
    text-align: center;
  }
</style>
